import { Injectable } from '@angular/core';
import { Actions, ofAction, Store, UpdateState } from '@ngxs/store';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class StoreProviderService {
    static store: Store | undefined = undefined;
    static actions$: Actions | undefined = undefined;
    static initialStates: { [key: string]: any };

    constructor(store: Store, actions$: Actions) {
        actions$.pipe(
            ofAction(UpdateState),
            tap((s: UpdateState) => {
                StoreProviderService.initialStates = {...StoreProviderService.initialStates, ...s.addedStates};
            })
        ).subscribe();
        StoreProviderService.store = store;
        StoreProviderService.actions$ = actions$;
    }
}
